import { LazyLoad } from '@cian/lazyload-component';

export class StringLazyLoad extends LazyLoad<string> {}

export const waitForImage = (src: string): Promise<string> => {
  return new Promise(function(resolve, reject) {
    var image = new Image;

    image.onload = () => {
      if (image.naturalHeight + image.naturalWidth === 0) {
        reject(new Error('wrong image dimensions'));
      }

      resolve(src);
    };
    image.onerror = (e: ErrorEvent) => {
      reject(e);
    }
    image.src = src;
  });
}
